import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Ruler, X } from "lucide-react";
import { useRooms } from "../lib/rooms";

export default function FitFilter({ sp, set }) {
  const { rooms } = useRooms();
  const [w, h, d] = (sp.get("fit") || "").split("x");
  const [custom, setCustom] = useState({ w: w || "", h: h || "", d: d || "" });
  const [, setSp] = useSearchParams();
  useEffect(() => setCustom({ w: w || "", h: h || "", d: d || "" }), [w, h, d]);
  const clear = () => { const n = new URLSearchParams(sp); n.delete("fit"); n.delete("unknown"); setSp(n); };
  const active = !!sp.get("fit");
  const apply = (r) => set("fit", `${r.w}x${r.h}x${r.d}`);
  const ok = custom.w > 0 && custom.h > 0 && custom.d > 0;
  const inp = "w-full bg-black/40 border border-white/10 rounded-lg px-2 py-1.5 text-xs focus:border-[#ff5500] outline-none";
  return (
    <div data-testid="fit-filter">
      <p className="text-xs uppercase tracking-wider text-slate-500 mb-3 flex items-center gap-1"><Ruler size={12} />Fits my space</p>
      {active && (
        <p data-testid="fit-filter-active" className="flex items-center justify-between text-xs mb-3 rounded-full bg-[#00f0ff]/10 text-[#00f0ff] pl-3 pr-1 py-1">
          W {w} × H {h} × D {d} cm
          <button data-testid="fit-filter-clear" onClick={clear} className="p-1 rounded-full hover:bg-white/10" aria-label="clear"><X size={12} /></button>
        </p>
      )}
      {rooms.length > 0 && (
        <select data-testid="fit-room-select" value="" onChange={(e) => { const r = rooms.find((x) => x.id === e.target.value); if (r) { setCustom({ w: r.w, h: r.h, d: r.d }); apply(r); } }}
          className="w-full mb-2 bg-black/40 border border-white/10 rounded-lg px-2 py-2 text-sm">
          <option value="">Pick a saved space…</option>
          {rooms.map((r) => <option key={r.id} value={r.id}>{r.name} · {r.w}×{r.h}×{r.d}</option>)}
        </select>
      )}
      <div className="grid grid-cols-3 gap-1.5">
        {[["w", "W"], ["h", "H"], ["d", "D"]].map(([k, l]) => (
          <input key={k} data-testid={`fit-${k}-input`} type="number" min="1" placeholder={`${l} cm`} value={custom[k]} onChange={(e) => setCustom({ ...custom, [k]: e.target.value })} className={inp} />
        ))}
      </div>
      <button data-testid="fit-apply-btn" disabled={!ok} onClick={() => apply(custom)} className="mt-2 w-full py-1.5 rounded-full text-xs font-semibold bg-white text-black hover:bg-[#ff5500] hover:text-white transition-colors disabled:opacity-40">Show what fits</button>
      {active && (
        <label className="mt-3 flex items-center gap-2 text-xs text-slate-400 cursor-pointer">
          <input data-testid="fit-hide-unknown" type="checkbox" checked={sp.get("unknown") === "hide"} onChange={(e) => set("unknown", e.target.checked ? "hide" : "")} className="accent-[#ff5500]" />Hide items with unknown size
        </label>
      )}
    </div>
  );
}
